import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        if (document.body.clientHeight > window.innerHeight) {
            let scroller = document.body;
            let scrollerStyles = getComputedStyle(scroller);
            scrollerStyles.getPropertyValue('--scrollbar-width');

            requestAnimationFrame(()=>{
                scroller.style.setProperty('--scrollbar-width', (window.innerWidth - scroller.clientWidth) / 10 +
                    'rem');
            });
        }
    }
}
